import { complectationsField, CREDIT_FORM_ID, creditFields, creditForm, models, settings } from './constants';
import { state } from './state';
import { getField, getPacket, getSale } from './getters';
import {
  getPercentListFromTerm,
  setPrice,
  setPv,
  setSale,
  setSrok,
  setTradeIn,
  setTradeInOther,
  setPacket,
  calculateCredits,
  setBenefit,
} from './actions';
import { updateChoose } from '../_label-choose';
import Loader from '../../classes/Loader';

export let INSTALLMENT_ACTIVE = false;
const FINANCE_ACTIVE = true;
export let formLoader = null;

const handleModelChange = e => {
  const value = e.currentTarget.dataset.model;
  state.complectation = null;
  models.filter((index, model) => model.classList.contains('active'))
        .each((index, model) => model.classList.remove('active'));
  e.currentTarget.classList.add('active');
  formLoader.start();

  if (value) {
    $.ajax({
      type: 'POST',
      url: '/ajax/finance/complectations/',
      data: {
        model: value,
      },
      success({ modifications }) {
        hideForm();
        setComplectations(modifications);
        formLoader.stop();
      },
    })
  } else {
    setComplectations([]);
    hideForm();
    formLoader.stop();
  }
}

const getSalePrice = () => {
  if (!FINANCE_ACTIVE) {
    return state.complectation.price;
  }
  // const finance = getSale('sale') ?? 0;
  const benefit = getSale('benefit') ?? 0;
  return state.complectation.price - benefit;
}

const handleComplectationChange = ({ target: { value } }) => {
  if (value) {
    const checkboxes = creditForm.find('[data-finance="trade-in"], [data-finance="trade-in-other"], [data-finance="sale"], [data-finance="benefit"]');
    $(checkboxes).removeClass('hide');
    const saleCheckbox = $('[data-finance="sale"]');

    getField('list')
      .querySelectorAll('[name="complectation_id"]')
      .forEach(input => input.value = value);
    state.complectation = { ...state.complectations.find(({ id }) => parseInt(id) === parseInt(value)) };
    state.sale_price = getSalePrice();

    $(state.complectation.sales).each(function(index, element) {
      if(element.value == '0') {
        if(element.id == 3) {
          $('[data-finance="trade-in"]').addClass('hide');
        }
        if(element.id == 4) {
          $('[data-finance="sale"]').addClass('hide');
        }
        if(element.id == 5) {
          $('[data-finance="trade-in-other"]').addClass('hide');
        }
        if(element.id == 6) {
          $('[data-finance="benefit"]').addClass('hide');
        }
      }
    })
    if (FINANCE_ACTIVE && !saleCheckbox.hasClass('hide')) {
      $('[data-finance="sale"]').addClass('hide');
    }
    setupForm();
  }
  if (document.querySelector("[name='benefit']")?.checked == false) {
    document.querySelector("[name='benefit']").click();
  }
}

const handleSrokChange = e => {
  settings.YEARS = e.target.value / settings.MONTH;
  setPv();
}

const handleSaleChange = e => {
  const checkboxes = creditForm.find('[name="trade-in"], [name="trade-in-other"]');
  const benefitCheckbox = creditForm.find('[name="benefit"]');
  const checked = checkboxes.filter((index, checkbox) => checkbox.checked === true);
  let value = checked.length ? checked[0].value : 0;
  let benefit = benefitCheckbox[0]?.checked ? benefitCheckbox[0].value : 0;

  if (checked.length === 2) {
    checkboxes.filter((index, checkbox) => checkbox.name !== e.target.name)
              .each((index, checkbox) => checkbox.checked = false);
    value = e.target.value;
  }

  state.sale_price = getSalePrice() - value - benefit;
  setPrice();
  setPv();
}

const setComplectations = modifications => {
  let html = '';
  let setted = false;
  state.complectations = [];

  for (const modification of modifications) {
    for (const complectation of modification['complectations']) {
      state.complectations.push(complectation);
      html += `<div class="label-choose__item${!setted ? ' active' : ''}" data-value="${complectation['id']}">${modification['name']} ${complectation['name']}</div>`;
      setted = true;
    }
  }
  complectationsField.html(html);

  if (html) {
    complectationsField.show();
    updateChoose();
    handleComplectationChange({ target: { value: complectationsField.find('.label-choose__item').eq(0).data('value') } })
  } else {
    complectationsField.hide();
  }
}

const hideForm = () => creditFields.each((index, field) => field.style.display = 'none');

const setupForm = () => {
  creditFields.each((index, field) => {
    field.style.display = '';

    switch (field.dataset.finance) {
      case 'price':
        setPrice();
        break;
      case 'sale':
        setSale(getSale('sale'));
        break;
      case 'trade-in':
        setTradeIn(getSale('tradein'));
        break;
      case 'trade-in-other':
        setTradeInOther(getSale('tradeinother'));
        break;
      case 'benefit':
        setBenefit(getSale('benefit'));
        break;
      case 'pv':
        setPv();
        break;
      case 'srok':
        setSrok();
        break;
      case 'installment-packet':
        setPacket(getPacket());
        break;
      default:
        break;
    }

  });
}
const handleToggleListItem = e => {
  if(e.target.href) {
    return;
  }
  e.preventDefault();
  const target = $(e.currentTarget);
  const item = target.parents('.finance__list-item');
  item.toggleClass('opened');
  item.find('.finance__list-item-body').toggle();
}

const handleTabChange = e => {
  if (e.target.classList.contains('tabs__head-item_active')) {
    return;
  }

  INSTALLMENT_ACTIVE = e.target.dataset.tabsValue === 'installment';
  getField('list')
    .querySelectorAll('[name="is_installment"]')
    .forEach(input => input.value = INSTALLMENT_ACTIVE ? 1 : 0);
  setCreditData();
  if (state.complectation) {
    setupForm();
  }
}

const setCreditData = () => {
  let minCredit = 9999999999;
  let maxCredit = 0;
  let creditIntervals = [];
  let terms = [];

  state.credits.forEach(credit => {
    if (INSTALLMENT_ACTIVE) {
      // Минимально и максимально возможный кредит
      if (credit.installment && credit.installment.min_sum < minCredit) {
        minCredit = credit.installment.min_sum;
      }

      if (credit.installment && credit.max_sum > maxCredit) {
        maxCredit = credit.installment.max_sum;
      }

      Object.keys((credit.installment || {}).info || {}).forEach(term => terms.push(term));

    } else {
      // Минимально и максимально возможный кредит
      if (credit.min_sum < minCredit) {
        minCredit = credit.min_sum;
      }

      if (credit.max_sum > maxCredit) {
        maxCredit = credit.max_sum;
      }

      Object.keys(credit.data).forEach(term => {
        creditIntervals = [...creditIntervals, ...getPercentListFromTerm(credit.data[term])];
        terms.push(term);
      });
    }

  });

  settings.MIN_CREDIT = parseInt(minCredit);
  settings.MAX_CREDIT = parseInt(maxCredit);

  // Скрываем ненужные сроки по кредиту
  terms = Array.from(new Set(terms));
  $(getField('srok')).find('.label-choose__item').each((i, e) => {
    const term = e.dataset.value;
    if (!terms.includes(term)) {
      e.style.display = 'none';
    } else {
      e.style.display = '';
    }
  });

  // Минимальный и максимально вохможный процент
  if (INSTALLMENT_ACTIVE) {
    settings.MIN_CREDIT_PERCENT = 0;
    settings.MAX_CREDIT_PERCENT = 1;
  } else {
    creditIntervals = Array.from(new Set(creditIntervals)).map(percent => parseInt(percent));
    settings.MIN_CREDIT_PERCENT = Math.min(...creditIntervals) / 100;
    settings.MAX_CREDIT_PERCENT = Math.max(...creditIntervals) / 100;
  }
}

const setComplectationInfo = () => {
  state.complectations = window.complectations;
}

if (creditForm.length) {
  models.on('click', handleModelChange);
  creditForm.on('change', '[name=srok]', handleSrokChange);
  creditForm.on('change', '[name="trade-in"], [name="trade-in-other"], [name="benefit"]', handleSaleChange);
  creditForm.on('change', '[name="installment-packet"]', calculateCredits);
  creditForm.on('change', '[name=complectation]', handleComplectationChange);

  $('.finance__list-item-head').click(handleToggleListItem);
  $('.tabs__head-item').click(handleTabChange);
  setCreditData();
  setComplectationInfo();
  handleComplectationChange({ target: { value: complectationsField.find('.label-choose__item').eq(0).data('value') } });

  $(state.complectation.sales).each(function(index, element) {
    if(element.value == '0') {
      if(element.id == 3) {
        $('[data-finance="trade-in"]').addClass('hide');
      }
      if(element.id == 4) {
        $('[data-finance="sale"]').addClass('hide');
      }
      if(element.id == 5) {
        $('[data-finance="trade-in-other"]').addClass('hide');
      }
      if(element.id == 6) {
        $('[data-finance="benefit"]').addClass('hide');
      }
    }
  })

  formLoader = Loader.instance(CREDIT_FORM_ID);
}
